import React from "react"
import styled, { keyframes } from "styled-components"
import { Link } from "gatsby"
import { IntroDataStructure } from "../../data/IntroductionData"

export default function ChildThirdSectionInformation() {
  return (
    <>
      <Wrapper>
        <WrapperInformation>
          <WrapperInformationParagraph>
            introduction
          </WrapperInformationParagraph>
          <WrapperInformationBigParagraph>
            Discuss all the details we have in Veu
          </WrapperInformationBigParagraph>
          <WrapperSubtitle>
            After reading you will know all the details of Veu CSS. If you want
            a good website with components, design. Then you will need to move
            on to eye documentation.
          </WrapperSubtitle>
          <Link to="/" style={{ textDecoration: "none" }}>
            <WrapperButton>
              <img
                src="/images/icons/tutorials.svg"
                alt=""
                style={{ maxWidth: "100%" }}
              />
              <WrapperButtonParagraph>
                Go to documentation
              </WrapperButtonParagraph>
            </WrapperButton>
          </Link>
        </WrapperInformation>
        <SectionWrapper>
          {IntroDataStructure.map(item => {
            return (
              <>
                <Link to="/" style={{ textDecoration: "none" }}>
                  <CardWrapperForSection>
                    <CardWrapperChild>
                      <div>
                        <ImageComponentWrapperChild src={item.image} alt="" />
                      </div>
                      <CardWrapperComponent>
                        <CardWrapperComponentParagraph>
                          Comming Soon
                        </CardWrapperComponentParagraph>
                        <CardWrapperComponentBigParagraph>
                          {item.title}
                        </CardWrapperComponentBigParagraph>
                        <CardWrapperComponentSubtitle>
                          {item.description}
                        </CardWrapperComponentSubtitle>
                        <CardWrapperInfo>
                          <CardWrapperInfoComponent>
                            <CardWrapperInfoImage
                              src="/images/icons/file.svg"
                              alt=""
                            />
                          </CardWrapperInfoComponent>
                          <CardWrapperParagraphComponent>
                            Documentation
                          </CardWrapperParagraphComponent>
                        </CardWrapperInfo>
                        <CardWrapperInfo>
                          <CardWrapperInfoComponent>
                            <CardWrapperInfoImage
                              src="/images/icons/code.svg"
                              alt=""
                            />
                          </CardWrapperInfoComponent>
                          <CardWrapperParagraphComponent>
                            Read, examples
                          </CardWrapperParagraphComponent>
                        </CardWrapperInfo>
                      </CardWrapperComponent>
                    </CardWrapperChild>
                    <CardBackgroundWrapper></CardBackgroundWrapper>
                  </CardWrapperForSection>
                </Link>
              </>
            )
          })}
        </SectionWrapper>
      </Wrapper>
    </>
  )
}

const load = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 360px auto;
  gap: 60px;
  justify-items: center;
  position: relative;
  max-width: 1234px;
  align-items: center;
  padding: 0px 30px;
  margin: 50px auto 200px;
  pointer-events: visible;
`

const WrapperInformation = styled.div`
  position: relative;
  display: grid;
  align-content: start;
  justify-items: start;
  gap: 20px;
  max-width: 360px;
`

const WrapperInformationParagraph = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  text-transform: uppercase;
  margin: 0px;
  color: rgba(0, 0, 0, 0.7);
`

const WrapperInformationBigParagraph = styled.h2`
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  margin: 0px;
  color: black;
`

const WrapperSubtitle = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 130%;
  margin: 0px;
  color: black;
`

const WrapperButton = styled.button`
  transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
  display: flex;
  background: linear-gradient(
    rgba(24, 32, 79, 0.4) 0%,
    rgba(24, 32, 79, 0.4) 100%
  );
  border-radius: 30px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 20px 40px,
    rgba(0, 0, 0, 0.2) 0px 0px 0px 0.5px inset;
  border: none;
  padding: 10px 30px 10px 12px;
  cursor: pointer;

  :hover {
    transform: translateY(-2px);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 20px 40px,
      rgba(0, 0, 0, 0.3) 0px 0px 0px 0.5px inset,
      rgba(0, 0, 0, 0.3) 0px 10px 40px inset;
  }
`

const WrapperButtonParagraph = styled.p`
  font-style: normal;
  font-size: 15px;
  font-weight: normal;
  line-height: 130%;
  text-align: center;
  color: white;
  margin: auto auto auto 8px;
  text-transform: capitalize;
`

const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
`

const CardWrapperForSection = styled.div`
  position: relative;
`

const CardWrapperChild = styled.div`
  transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
  position: relative;
  width: 240px;
  height: 280px;
  backdrop-filter: blur(40px);
  border-radius: 0px 30px 40px 40px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: rgba(24, 32, 79, 0.25) 0px 40px 80px,
    rgba(255, 255, 255, 0.5) 0px 0px 0px 0.5px inset;
  z-index: 1;
`

const ImageComponentWrapperChild = styled.img`
  width: 32px;
  height: 32px;
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0;
  animation: 1s ease 0s 1 normal forwards running ${load};
  max-width: 100%;
`

const CardWrapperComponent = styled.div`
  display: grid;
  position: relative;
  gap: 12px;
  text-align: left;
  max-width: 200px;
`

const CardWrapperComponentParagraph = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 130%;
  text-transform: uppercase;
  margin: 0px;
  color: rgba(0, 0, 0, 0.7);
  height: 16px;
  text-align: left;
`

const CardWrapperComponentBigParagraph = styled.h2`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  margin: 0px;
  color: black;
`

const CardWrapperComponentSubtitle = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 130%;
  margin: 0px;
  color: rgba(0, 0, 0, 0.7);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const CardWrapperInfo = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 32px auto 40px;
`

const CardWrapperInfoComponent = styled.div`
  display: grid;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50px;
`

const CardWrapperInfoImage = styled.img`
  margin: auto;
  width: 20px;
  height: 20px;
  max-width: 100%;
`

const CardWrapperParagraphComponent = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
  margin: auto 0px;
  line-height: 130%;
`

const CardBackgroundWrapper = styled.div`
  position: absolute;
  transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
  width: 220px;
  height: 280px;
  background: linear-gradient(rgb(96, 3, 139) 0%, rgb(26, 172, 204) 100%);
  border-radius: 0px 40px 40px;
  transform: skewY(8deg);
  transform-origin: left top;
  top: 0px;

  ${CardWrapperForSection}:hover & {
    transform: skewY(15deg);
    width: 200px;
  }
`
